import React from "react";

export default function WordWide({ data }) {
  const urlApi = process.env.REACT_APP_STRAPI_URL;
  return (
    <div className="bg-[#0a0c1a]  mt-[70px] md:mt-[100px] lg:mt-[90px]  flex justify-center p-1.5 sm:p-2 md:p-3  items-center">
      <div className="  container  flex flex-col  lg:flex-row items-center gap-10 text-sidom-light  ">
        <div className="flex justify-center   items-center rounded-2xl">
          <div className="w-full h-full     flex items-stretch">
            <video
              autoPlay
              playsInline
              muted
              loop
              className=" h-full max-w-screen-sm  max-h-[700px]"
            >
              <source
                src={`${urlApi}/uploads/sidom_hiro_eb42eafb6c.mp4`}
                type="video/webm"
              />
            </video>
          </div>
        </div>

        <div className=" leading-[1.3] mb-[70px] md:mb-[100px] lg:mb-[90px] lg:text-left w-full px-2 md:px-0 lg:px-0 md:p-0 md:w-[40%]">
          <h1 className="text-sidom-orange text-3xl md:text-[40px] lg:text-[45px] leading-tight font-bold mb-4">
            {Array.isArray(data) && data[0]?.titulo
              ? data[0].titulo
              : "Worldwide"}
          </h1>
          <p className="text-xs sm:text-sm md:text-base lg:text-xl text-left">
            {Array.isArray(data) && data[0]?.descripcion
              ? data[0].descripcion
              : ""}
          </p>
        </div>
      </div>
    </div>
  );
}
